export default "__VITE_ASSET__qGn9_h5$__"